module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMsIHlvdSBkaWQgaXQuIFRoZSBmb3JjZSB3aWxsIGJlIHdpdGggeW91LiBBbHdheXMuIFJlZmVyZW5jZTogW3hGT1JDRSBFeHBsb2l0IFBvc3QgTW9ydGVtXShodHRwczovL2Jsb2cuZm9yY2VkYW8uY29tL3hmb3JjZS1leHBsb2l0LXBvc3QtbW9ydGVtLTdmYTlkY2JhMmFjMykK"


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/maytheforcebewithyou_complete.md
// module id = 1838
// module chunks = 0